import { imageListItem } from "../theme/default/image-list-item";

export const buildImageList = images => {
  return images.map(image => {
    const data = {
      childrenData: {
        childrenList: imageListItem(image)
      },
      key: "selectedData",
      type: "listItemWrapper",
      title: "",
      selectedData: { ...image },
      renderFields: true,
      childrenType: "image-list-item"
    };

    return data;
  });
};
